import { FC } from 'react'
import { IconType } from 'react-icons'
import useRootColor from '../../../hooks/useRootColor'

type Props = {
  Icon: IconType
  text: string
}
const IconText: FC<Props> = (props) => {
  const { Icon, text } = props
  const { iconColor } = useRootColor()

  return (
    <span className="text-small">
      <Icon size="1rem" color={iconColor} />
      <span className="ms-1">{text}</span>
    </span>
  )
}

export default IconText
